"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.CheckFat = exports.ChevronDown = exports.Check = exports.Close = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Close = exports.Close = function Close(props) {
	return _react2.default.createElement(
		"svg",
		_extends({ viewBox: "0 0 24 24", fill: "#000000" }, props),
		_react2.default.createElement("path", { d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" }),
		_react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" })
	);
};

var Check = exports.Check = function Check(props) {
	return _react2.default.createElement(
		"svg",
		_extends({ fill: "#000000", viewBox: "0 0 24 24" }, props),
		_react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
		_react2.default.createElement("path", { d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" })
	);
};

var ChevronDown = exports.ChevronDown = function ChevronDown(props) {
	return _react2.default.createElement(
		"svg",
		_extends({ fill: "#000000", viewBox: "0 0 24 24" }, props),
		_react2.default.createElement("path", { d: "M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z" }),
		_react2.default.createElement("path", { d: "M0-.75h24v24H0z", fill: "none" })
	);
};

var CheckFat = exports.CheckFat = function CheckFat(props) {
	return _react2.default.createElement(
		"svg",
		_extends({ viewBox: "0 0 18 15" }, props),
		_react2.default.createElement(
			"g",
			{ stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", transform: "translate(-1185.000000, -584.000000)" },
			_react2.default.createElement(
				"g",
				{ transform: "translate(1109.000000, 571.000000)", fill: "#FFFFFF" },
				_react2.default.createElement("path", { d: "M82.1171729,27.3506844 L76.2460932,21.3688627 C76.0820309,21.2006988 76,20.9844884 76,20.7202314 C76,20.4559744 76.0820309,20.239764 76.2460932,20.0716002 L77.5468713,18.7743376 C77.7109336,18.5821508 77.9160111,18.4860571 78.1621042,18.4860571 C78.4081974,18.4860571 78.6249939,18.5821508 78.8124933,18.7743376 L82.7499839,22.8102655 L91.1874638,14.1618486 C91.3749632,13.9696618 91.5917597,13.8735681 91.8378529,13.8735681 C92.083946,13.8735681 92.2890235,13.9696618 92.4530858,14.1618486 L93.7538639,15.4591112 C93.9179262,15.627275 93.9999571,15.8434854 93.9999571,16.1077424 C93.9999571,16.3719994 93.9179262,16.5882098 93.7538639,16.7563737 L83.3827949,27.3506844 C83.2187326,27.5428712 83.0077956,27.6389649 82.7499839,27.6389649 C82.4921722,27.6389649 82.2812352,27.5428712 82.1171729,27.3506844 Z" })
			)
		)
	);
};